import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "prmu_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant, qty = 1) => {
    setItems((prev) => {
      const key = product.id + "|" + (variant?.sku || "");
      const idx = prev.findIndex((i) => i.key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: Math.min(99, next[idx].quantity + qty) };
        return next;
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          product_name: product.name,
          product_slug: product.slug,
          image_url: product.image_url,
          variant_sku: variant?.sku || null,
          variant_label: variant?.label || null,
          unit_price_cents: variant ? variant.price_cents : product.price_cents,
          quantity: qty,
        },
      ];
    });
  };

  const update = (key, qty) => {
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity: qty } : i)));
  };
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((n, i) => n + i.quantity, 0), [items]);
  const subtotal_cents = useMemo(
    () => items.reduce((n, i) => n + i.unit_price_cents * i.quantity, 0),
    [items]
  );

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, count, subtotal_cents }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
